import * as React from "react";
import type { SVGProps } from "react";
const SvgCalendar = (props: SVGProps<SVGSVGElement>) => (
  <svg fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      d="M7 11a1 1 0 1 0 0-2 1 1 0 0 0 0 2M13 10a1 1 0 1 1-2 0 1 1 0 0 1 2 0M17 11a1 1 0 1 0 0-2 1 1 0 0 0 0 2M8 13.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0M12 14.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2M18 13.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0M7 18a1 1 0 1 0 0-2 1 1 0 0 0 0 2M13 17a1 1 0 1 1-2 0 1 1 0 0 1 2 0M17 18a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7.75 3a.75.75 0 0 0-1.5 0H6a4 4 0 0 0-4 4v11a4 4 0 0 0 4 4h12a4 4 0 0 0 4-4V7a4 4 0 0 0-4-4h-.25a.75.75 0 0 0-1.5 0zm8.5 3V4.5h-8.5V6a.75.75 0 0 1-1.5 0V4.5H6A2.5 2.5 0 0 0 3.5 7v11A2.5 2.5 0 0 0 6 20.5h12a2.5 2.5 0 0 0 2.5-2.5V7A2.5 2.5 0 0 0 18 4.5h-.25V6a.75.75 0 0 1-1.5 0"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgCalendar;
